import React from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, Container } from "react-bootstrap";
import { CalendarDays, Ellipsis } from 'lucide-react';

function Header() {
  return (
    <>
    <div className="logoHolder" style={{ height: '80px', backgroundColor: '#FFFFFF', width: '100vw', marginLeft: '-16px', marginRight: '-16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="top1st top-column"></div>
      <div className="top2nd top-column">
        <img src={require('../assets/img/Modern_Diagnostics_And_Nursing_Home_Logo.png')} alt="Modern Diagnostics And Nursing Home Logo" style={{ height:'60px', width:'auto' }} />
      </div>
      <div className="top3rd top-column"></div>
    </div>
    <Navbar bg="" variant="dark" expand="lg" sticky="top">
      <Container>
        {/* <Navbar.Brand as={Link} to="/">Medical Care</Navbar.Brand> */}
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <Ellipsis size={28} color="#60a9bd" />
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav" className="custom-navbar-collapse">
          <Nav className="w-100 align-items-center custom-mobile-nav">
            <div className="d-flex">
              <Nav.Link as={Link} to="/" className="custom-nav-link">HOME</Nav.Link>
              <Nav.Link as={Link} to="/about" className="custom-nav-link">ABOUT</Nav.Link>
              <Nav.Link as={Link} to="/services" className="custom-nav-link">Services</Nav.Link>
              <Nav.Link as={Link} to="/doctors" className="custom-nav-link">Doctors</Nav.Link>
              <Nav.Link as={Link} to="/gallery" className="custom-nav-link">Gallery</Nav.Link>
            </div>
            <div className="appo ms-auto">
              <Nav.Link
                as={Link}
                to="/appointment"
                className="custom-nav-link"
                style={{ backgroundColor: '#60a9bd', color: '#fff', borderRadius: '4px', padding: '8px 16px' }}
              >
                <CalendarDays size={16}/> Book Appointment
              </Nav.Link>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </>
  );
}

export default Header;